import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M225-66q-32 0-56-23-23-24-23-56v-670q0-33 23-56 24-24 56-24h329q16 0 31 7t26 18l179 179q11 11 18 26t7 31v489q0 32-24 56-23 23-56 23H225Zm321-603v-146H225v670h510v-484H586q-17 0-29-11-11-12-11-29ZM225-815v186-186 670-670Z"/>',
  f: '<path d="M225-66q-32 0-56-23-23-24-23-56v-670q0-32 23-56 24-24 56-24h329q16 0 31 7t26 18l179 179q11 11 18 26t7 31v489q0 32-24 56-24 23-56 23H225Zm321-603q0 17 11 29 12 11 29 11h149L546-815v146Z"/>',
};

export default data;
